export default __webpack_public_path__ + "136a78c.mp3";